import css from 'styled-jsx/css';

const styles = theme => {
  return css.resolve`
    .form-item-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      background: white;
      border-radius: 20px;

      margin-bottom: 16px;
      border: 1px solid ${theme.mainColor};
    }

    .no-border {
      border: none;
    }

    .image-doc {
      color: ${theme.titleColor};
      font-size: 14px;
      text-align: left;
      margin-right: 8px;
    }

    .icon-container {
      flex: 1 0 20%;
    }
    .icon-container.align-top {
      padding-top: 10px;
      align-self: flex-start;
    }

    .item-container {
      flex: 2 0 80%;
      max-width: 80%;
      padding: 10px 0;
    }

    .no-icon-item-container {
      flex: 1;
      max-width: 100%;
      padding: 10px 20px;
    }

    .form-label {
      color: ${theme.mainColor} !important;
    }

    .form-label-document {
      padding: 0px 0px 75px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    label {
      color: ${theme.mainColor} !important;
    }
  `;
};

export const global = css.global`
  .form-item-container div:not(.no-icon-item-container) .ant-form-item {
    margin-right: 20px;
    margin-bottom: 0;
  }

  .form-item-container .ant-form-item > .ant-form-item-label {
    padding-bottom: 0;
    line-height: 18px;
  }

  .form-item-container .ant-form-item > .ant-form-item-label > label {
    height: auto;
    min-height: 32px;
  }

  .form-item-container .ant-form-item > .ant-select-selection-item,
  .form-item-container .ant-form-item > .ant-upload-select,
  .form-item-container .ant-form-item .ant-input-number,
  .form-item-container .ant-form-item .ant-picker {
    width: 100%;
  }

  .form-item-container .ant-form-item > .ant-upload-select {
    margin-top: 15px;
    margin-bottom: 5px;
  }

  .form-item-container .ant-form-item .ant-input,
  .form-item-container .ant-form-item .ant-picker,
  .form-item-container .ant-form-item .ant-select,
  .form-item-container .ant-form-item .ant-select-selector {
    border: none;
  }
  .form-item-container .ant-select-dropdown,
  .form-item-container .ant-select-selection-item {
    text-align: left;
  }
  .form-item-container .ant-picker-dropdown.ant-picker-dropdown-placement-bottomLeft,
  .form-item-container .ant-select-dropdown.ant-select-dropdown-placement-bottomLeft {
    top: 35px !important;
  }

  .form-item-container .ant-form-item-control-input-content {
    text-align: left;
  }

  .form-item-container .form-item-radio-group {
    display: flex;
    flex-direction: column;
    padding: 5px 0px;
  }

  .form-item-container .form-item-radio-group .ant-radio-wrapper {
    margin: 5px 0px;
  }

  .legal-checkboxes-container .ant-form-item-control-input-content {
    text-align: left;
  }

  .legal-checkboxes-container .ant-row-middle {
    margin-bottom: 10px;
  }
`;
export default styles;
